import { render, staticRenderFns } from "./AddNewSite.vue?vue&type=template&id=12ad78ee&"
import script from "./AddNewSite.vue?vue&type=script&lang=js&"
export * from "./AddNewSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports